import React from "react";

function Cooking() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="335"
            height="273"
            fill="none"
            viewBox="0 0 335 273"
        >
            <path
                fill="#E8F6E6"
                d="M26.726 261.775s-56.832-59.385 2.729-124.321C89.015 72.519 57.617 24.916 118.893 5.676c61.276-19.24 183.265 10.137 157.466 92.674-25.799 82.536 88.343 46.838 46.971 162.687l-296.604.738z"
            ></path>
            <path
                fill="#FBFBFB"
                d="M104.271 57.769c-2.599-1.514-6.246-1.515-9.582-.116.958-2.22 4.186-3.58 4.186-3.58l-.475-2.315c-2.974.71-4.3 3.088-4.887 4.891-.354-1.245-1.53-2.9-5.175-3.467 0 0 .022 2.074 1.097 3.573-1.818-.282-3.603-.15-5.152.404-11.895 4.972.11 26.695 8.507 21.86.306-.243.584-.517.83-.819.06.072.126.148.197.228 2.092 2.556 5.65 1.133 7.762-.646 5.153-4.033 9.999-14.569 2.692-20.013z"
            ></path>
            <path
                fill="#FBFBFB"
                d="M121.107 66.45c-1.436-2.147-4.25-3.524-7.35-3.702 1.575-1.351 4.576-1.18 4.576-1.18l.507-1.964c-2.563-.575-4.487.76-5.615 1.93.196-1.094-.088-2.814-2.686-4.626 0 0-.766 1.607-.498 3.17a9.073 9.073 0 00-4.126-1.63c-11.054-.649-9.983 20.638-1.679 20.073a4.63 4.63 0 00.947-.319c.019.077.04.166.067.251.65 2.76 3.928 3.003 6.233 2.428 5.496-1.171 13.206-7.471 9.624-14.43z"
            ></path>
            <path
                fill="#FBFBFB"
                d="M244.418 76.57H78.505a3.252 3.252 0 00-3.252 3.252v.002a3.252 3.252 0 003.252 3.252h165.913a3.252 3.252 0 003.252-3.252v-.002a3.252 3.252 0 00-3.252-3.252z"
            ></path>
            <path
                fill="#24B73E"
                d="M267.801 230.728s4.741-11.518 14.982-6.002c10.242 5.515 4.389 17.448 4.389 17.448l-19.371-11.446z"
            ></path>
            <path
                fill="#000"
                d="M267.801 230.728s4.741-11.518 14.982-6.002c10.242 5.515 4.389 17.448 4.389 17.448l-19.371-11.446z"
                opacity="0.55"
            ></path>
            <path
                fill="#FBFBFB"
                d="M235.204 50.318a10.764 10.764 0 01-1.353-5.215v-5.82a.393.393 0 00.321-.385v-2.134a.402.402 0 00-.401-.402h-4.37a.403.403 0 00-.402.402v2.134a.395.395 0 00.322.385V45.1a10.742 10.742 0 01-1.354 5.214c-3.247 5.853-3.365 9.888-3.365 9.888v16.186a3.056 3.056 0 001.896 2.84c.373.153.773.233 1.176.232h7.83a3.066 3.066 0 002.836-1.895c.154-.372.234-.771.234-1.174V60.205s-.122-4.035-3.37-9.887zM219.674 50.318a10.741 10.741 0 01-1.354-5.215v-5.82a.395.395 0 00.322-.385v-2.134a.403.403 0 00-.402-.402h-4.369a.402.402 0 00-.402.402v2.134a.398.398 0 00.323.385V45.1a10.754 10.754 0 01-1.355 5.214c-3.247 5.853-3.366 9.888-3.366 9.888v16.186a3.068 3.068 0 003.069 3.069h7.83a3.067 3.067 0 003.071-3.07V60.206s-.12-4.035-3.367-9.887zM140.652 69.684a9.642 9.642 0 00-1.731-4.002l2.355-1.862a.85.85 0 00.248-1.01.845.845 0 00-.222-.297l-.394-.332a.843.843 0 00-.975-.09.844.844 0 00-.258.23l-.831 1.136c0-2.022-2.796-4.45-2.796-4.45-.727 1.605-.831 2.825-.624 3.746a9.692 9.692 0 00-13.992 8.468 9.693 9.693 0 0013.593 9.096 9.696 9.696 0 005.634-10.628l-.007-.005zM78.505 134.661h165.913a3.252 3.252 0 003.252-3.252v-.002a3.252 3.252 0 00-3.252-3.252H78.505a3.252 3.252 0 00-3.252 3.252v.002a3.252 3.252 0 003.252 3.252z"
            ></path>
            <path
                fill="#FBFBFB"
                d="M87.72 101.902a10.745 10.745 0 001.354-5.214v-5.816a.395.395 0 01-.324-.39V88.35a.402.402 0 01.402-.402h4.37a.402.402 0 01.401.402v2.134a.394.394 0 01-.322.385v5.816c.001 1.825.467 3.62 1.354 5.215 3.247 5.853 3.367 9.888 3.367 9.888v16.185a3.07 3.07 0 01-3.07 3.07H87.42a3.072 3.072 0 01-3.07-3.07v-16.185s.122-4.039 3.369-9.885zM103.251 101.902a10.76 10.76 0 001.352-5.214v-5.816a.396.396 0 01-.322-.386v-2.137a.403.403 0 01.402-.402h4.37a.403.403 0 01.401.402v2.134a.395.395 0 01-.321.385v5.816c.002 1.825.467 3.62 1.353 5.215 3.249 5.853 3.367 9.888 3.367 9.888v16.185c0 .814-.324 1.595-.899 2.171a3.074 3.074 0 01-2.171.899h-7.83a3.069 3.069 0 01-3.07-3.066V111.79s.119-4.042 3.368-9.888z"
            ></path>
            <path
                fill="#6D0000"
                d="M196.23 84.198s15.559-1.02 14.029-18.612c-1.531-17.591-33.669-32.395-49.484-28.823-15.815 3.57-19.385 25.38-21.936 47.953-2.55 22.574-55.606 23.97-28.818 54.96l67.966-2.169s17.474.256 17.218-15.941c-.256-16.197-7.392-20.789 1.025-37.368z"
            ></path>
            <path
                fill="#FFD1C5"
                d="M172.005 128.58s-7.27-4.973-6.886-7.778c.383-2.805 5.611-13.393 5.611-13.393l-17.711-13.136s-8.945 21.427-14.173 25.891c0 0-2.551 10.457 1.275 16.197 3.825 5.74 37.999 13.008 31.884-7.781z"
            ></path>
            <mask
                id="mask0_259_730"
                style={{ maskType: "luminance" }}
                width="35"
                height="49"
                x="138"
                y="94"
                maskUnits="userSpaceOnUse"
            >
                <path
                    fill="#fff"
                    d="M172.005 128.58s-7.27-4.973-6.886-7.778c.383-2.805 5.611-13.393 5.611-13.393l-17.711-13.136s-8.945 21.427-14.173 25.891c0 0-2.551 10.457 1.275 16.197 3.825 5.74 37.999 13.008 31.884-7.781z"
                ></path>
            </mask>
            <g mask="url(#mask0_259_730)">
                <path
                    fill="#FFAC9C"
                    d="M162.305 86.495l-10.524 7.778s-4.969 23.029 18.177 29.462l6.632-14.243-14.285-22.998z"
                ></path>
            </g>
            <path
                fill="#FFD1C5"
                d="M204.265 191.073l6.632 20.024 47.954-25.636s-3.699 12.63-8.417 17.346c-4.718 4.716-28.952 31.628-42.98 34.435-14.029 2.807-24.262-41.016-24.262-41.016l21.073-5.153z"
            ></path>
            <mask
                id="mask1_259_730"
                style={{ maskType: "luminance" }}
                width="76"
                height="53"
                x="183"
                y="185"
                maskUnits="userSpaceOnUse"
            >
                <path
                    fill="#fff"
                    d="M204.265 191.073l6.632 20.024 47.954-25.636s-3.699 12.63-8.417 17.346c-4.718 4.716-28.952 31.628-42.98 34.435-14.029 2.807-24.262-41.016-24.262-41.016l21.073-5.153z"
                ></path>
            </mask>
            <g mask="url(#mask1_259_730)">
                <path
                    fill="#FFAC9C"
                    d="M196.741 190.436l8.588 1.573c-3.118 4.234-8.017 12.391-7.824 22.957.125 6.793 2.43 18.703 8.673 20.235 1.753.431 3.687-.445 7.478-2.21 0 0 6.766-3.157 18.279-11.798 0 0-14.79 28.035-25.757 26.754-10.968-1.281-36.227-53.944-36.227-53.944l26.79-3.567z"
                ></path>
            </g>
            <path
                fill="#16640B"
                d="M172.005 128.58s18.113 7.909 21.427 15.305c3.313 7.397 12.752 48.719 12.752 48.719l-21.171 4.847-51.269-34.435 5.102-42.852s2.805 14.291 15.559 17.854c12.754 3.563 18.359-2.295 17.6-9.438z"
            ></path>
            <path
                fill="#FB9B16"
                d="M126.539 124.409s7.893 24.915 7.199 34.898c-.695 9.982-9.693 42.172-9.693 42.172l-8.843 22.617v34.349h63.939s-2.721-42.002-1.021-47.954c1.7-5.953 14.046-9.858 12.583-30.608-.849-12.073-6.801-21.638-6.801-21.638l-4.293-26.401-4.581-2.393 3.518 28.335-38.176-.849s-4.773-28.214-9.14-34.513a309.906 309.906 0 00-4.691 1.985z"
            ></path>
            <path
                fill="#FFD1C5"
                d="M201.714 69.915s-9.693 43.234-24.225 44.637c-14.532 1.402-29.299-12.881-24.47-25.507 0 0-2.95 1.275-4.226-1.53-1.276-2.805-1.53-11.096 3.699-13.52 5.23-2.425 7.015 2.296 6.377 6.122l12.882-14.921 12.37-3.7 17.593 8.419z"
            ></path>
            <path
                fill="#6D0000"
                d="M158.862 80.117s8.545-.765 11.096-4.846c0 0 13.646 1.02 16.707-6.632 0 0 9.693 7.78 16.708 5.74 7.014-2.041-9.183-16.452-9.183-16.452l-33.542 2.169-1.786 20.02z"
            ></path>
            <path
                fill="#001A4F"
                d="M248.893 149.268l18.815 1.09a2.928 2.928 0 012.519 4.085l-18.213 42.243a5.706 5.706 0 01-5.567 3.435l-18.813-1.091a2.92 2.92 0 01-1.331-.409 2.922 2.922 0 01-1.421-2.301c-.035-.47.045-.941.231-1.373l18.215-42.244a5.699 5.699 0 015.565-3.435z"
            ></path>
            <path
                fill="#6D0000"
                d="M160.902 40.071s8.808-9.82 4.592-15.433c-4.216-5.611-33.797-.51-32.267 14.03 1.531 14.538 19.131 11.35 19.131 11.35l8.544-9.947z"
            ></path>
            <path
                fill="#FFD1C5"
                d="M101.546 200.681s2.72 23.127 6.291 30.098c3.572 6.971 27.888 0 33.331-2.72 5.442-2.72 32.479-17.005 32.479-17.005s16.51 2.632 25.081-7.057c1.956-2.211 5.696-6.802 1.02-8.161-4.676-1.36-13.773 5.1-18.279 4.761 0 0 1.163-2.55 2.408-3.528 1.244-.979 1.078-2.51-.539-3.02-1.617-.51-6.979 3.997-8.076 5.271-1.097 1.275-49.059 12.924-49.91 12.839-.85-.085-.594-9.352-.594-9.352l-23.212-2.126z"
            ></path>
            <mask
                id="mask2_259_730"
                style={{ maskType: "luminance" }}
                width="102"
                height="40"
                x="101"
                y="194"
                maskUnits="userSpaceOnUse"
            >
                <path
                    fill="#fff"
                    d="M101.546 200.681s2.72 23.127 6.291 30.098c3.572 6.971 27.888 0 33.331-2.72 5.442-2.72 32.479-17.005 32.479-17.005s16.51 2.632 25.081-7.057c1.956-2.211 5.696-6.802 1.02-8.161-4.676-1.36-13.773 5.1-18.279 4.761 0 0 1.163-2.55 2.408-3.528 1.244-.979 1.078-2.51-.539-3.02-1.617-.51-6.979 3.997-8.076 5.271-1.097 1.275-49.059 12.924-49.91 12.839-.85-.085-.594-9.352-.594-9.352l-23.212-2.126z"
                ></path>
            </mask>
            <g mask="url(#mask2_259_730)">
                <path
                    fill="#FFAC9C"
                    d="M118.943 200.13l7.146 3.612-20.151 3.4s.256 19.641 6.632 22.448c6.376 2.806 27.12.801 60.156-16.58 0 0-40.014 29.081-55.835 27.547-15.822-1.534-26.273-39.281-26.273-39.281l28.325-1.146z"
                ></path>
            </g>
            <path
                fill="#16640B"
                d="M137.497 142.313l1.342-22.146s-3.031.977-7.331 2.699c2.125 3.494 4.317 11.871 5.989 19.447zM133.738 159.313c.332-7.644-.472-19.557-7.046-34.415-8.974 3.988-20.128 10.178-23.052 17.201-5.102 12.244-7.653 33.925-4.338 60.708l26.783.935a420.262 420.262 0 005.464-27.658c1.328-8.141 1.996-12.302 2.189-16.771z"
            ></path>
            <path
                fill="#FFD1C5"
                d="M250.44 202.802s17.6-13.775 17.472-26.273c-.128-12.498-14.156-7.779-14.79-6.122-.633 1.657-9.272 12.02-2.677 16.198 6.596 4.177 2.666 11.993-.005 16.197z"
            ></path>
            <path
                fill="#848484"
                d="M305.995 252.349H25.465c-6.544 0-12.57 2.207-15.72 5.757L.63 268.374c-1.846 2.08.587 4.626 4.425 4.626h323.929c4.082 0 6.481-2.843 4.136-4.912l-12.423-10.998c-3.357-2.971-8.844-4.741-14.702-4.741z"
            ></path>
            <path
                fill="#001A4F"
                d="M115.308 253.687c1.33 5.436 16.478 9.725 34.981 9.725 18.502 0 33.65-4.289 34.982-9.725h-69.963z"
            ></path>
            <path
                fill="#0A397A"
                d="M150.289 258.769c19.378 0 35.087-2.323 35.087-5.188 0-2.866-15.709-5.188-35.087-5.188-19.378 0-35.087 2.322-35.087 5.188 0 2.865 15.709 5.188 35.087 5.188z"
            ></path>
            <path
                fill="#168F26"
                d="M227.914 233.33s-5.848-2.481-4.342-10.1c0 0 9.48 3.367 4.342 10.1z"
            ></path>
            <path
                fill="#168F26"
                d="M230.077 233.018s6.341-.361 7.495-8.042c0 0-10.064-.029-7.495 8.042z"
            ></path>
            <path
                fill="#0E7A1A"
                d="M231.584 226.078a1.928 1.928 0 00-3.855 0v6.426a1.928 1.928 0 103.855 0v-6.426z"
            ></path>
            <path
                fill="#FFC224"
                d="M244.689 229.49c-6.223-2.647-9.38 2.647-9.38 2.647l-5.87 30.783-5.868-30.783s-3.157-5.294-9.38-2.647c-6.224 2.647-10.96 17.254-4.645 27.253 5.909 9.354 18.318 7.385 19.893 7.092 1.577.293 13.986 2.262 19.893-7.092 6.317-9.999 1.581-24.606-4.643-27.253z"
            ></path>
            <path
                fill="#F5A501"
                d="M218.923 232.243s-14.6 20.909 2.327 29.414l-2.327-29.414zM239.833 232.243s15.107 20.909-2.404 29.414l2.404-29.414z"
            ></path>
            <path
                fill="#FFC224"
                d="M238.494 230.372c-3.947-4.154-8.134-.969-9.055-.166-.919-.799-5.107-3.988-9.053.166-4.464 4.706-11.98 22.517 0 30.783 2.318 1.599 7.454 2.401 8.865 2.597v.05l.188-.025.19.025v-.05c1.41-.196 6.547-.997 8.865-2.597 11.98-8.266 4.469-26.077 0-30.783z"
            ></path>
            <path
                fill="#F5A501"
                d="M229.439 235.372c-.078 2.236-.193 4.444-.291 6.648a239.335 239.335 0 00-.219 6.598 103.02 103.02 0 00.076 6.578c.055 1.093.12 2.19.231 3.285a70.95 70.95 0 00.422 3.297c-.94-2.036-1.477-4.251-1.804-6.471a41.873 41.873 0 01-.394-6.713c.041-2.237.221-4.469.542-6.682a41.546 41.546 0 011.437-6.54z"
            ></path>
            <path
                fill="#24B73E"
                d="M249.242 267.112s19.81-4.688 30.446-2.211c10.635 2.476 24.843-1.729 20.993-11.214-3.85-9.486-13.505-11.52-13.505-11.52s1.223-16.511-15.252-17.8c-16.475-1.29-28.86 6.11-25.935 17.583 0 0-8.927 11.247.036 17.099l3.217 8.063z"
            ></path>
            <mask
                id="mask3_259_730"
                style={{ maskType: "luminance" }}
                width="60"
                height="44"
                x="242"
                y="224"
                maskUnits="userSpaceOnUse"
            >
                <path
                    fill="#fff"
                    d="M249.242 267.112s19.81-4.688 30.446-2.211c10.635 2.476 24.843-1.729 20.993-11.214-3.85-9.486-13.505-11.52-13.505-11.52s1.223-16.511-15.252-17.8c-16.475-1.29-28.86 6.11-25.935 17.583 0 0-8.927 11.247.036 17.099l3.217 8.063z"
                ></path>
            </mask>
            <g mask="url(#mask3_259_730)">
                <path
                    fill="#000"
                    d="M230.567 263.412l17.356-5.167s-4.527-4.527-1.152-9.851c3.375-5.324-2.587-15.122-2.587-15.122l-13.617 30.14zM250.261 263.412s27.841-10.968 35.19-1.42l7.348 9.549-47.603-.113 5.065-8.016z"
                    opacity="0.55"
                ></path>
                <path
                    fill="#000"
                    d="M292.799 245.666l4.703 5.151s2.275 7.001-5.151 7.001c0 0 5.178 4.417.113 9.306-5.065 4.889-15.305 1.055-15.305 1.055l15.64-22.513zM251.77 248.394s2.953-14.999-1.617-24.174l3.859-2.409s2.743 12.551-2.242 26.583z"
                    opacity="0.55"
                ></path>
            </g>
            <path
                fill="#24B73E"
                d="M253.764 252.919s6.813-11.227 4.64-22.783c-2.174-11.556 12.606-10.765 13.516-5.769 0 0 5.941-1.559 7.859 1.784 1.918 3.344 4.218 5.296.045 9.28 0 0 10.635-.871 14.261 9.329 0 0 4.017 2.936 3.388 7.853-.628 4.918-7.477 3.194-7.477 3.194s2.898 11.069-5.425 11.372c-3.134.113-17.011-8.891-26.651-4.53 0 0-10.87 6.353-14.291 6.097-3.422-.256-5.429-6.125-3.905-8 1.523-1.874 11.79-5.643 14.04-7.827z"
            ></path>
            <mask
                id="mask4_259_730"
                style={{ maskType: "luminance" }}
                width="59"
                height="49"
                x="239"
                y="220"
                maskUnits="userSpaceOnUse"
            >
                <path
                    fill="#fff"
                    d="M253.764 252.919s6.813-11.227 4.64-22.783c-2.174-11.556 12.606-10.765 13.516-5.769 0 0 5.941-1.559 7.859 1.784 1.918 3.344 4.218 5.296.045 9.28 0 0 10.635-.871 14.261 9.329 0 0 4.017 2.936 3.388 7.853-.628 4.918-7.477 3.194-7.477 3.194s2.898 11.069-5.425 11.372c-3.134.113-17.011-8.891-26.651-4.53 0 0-10.87 6.353-14.291 6.097-3.422-.256-5.429-6.125-3.905-8 1.523-1.874 11.79-5.643 14.04-7.827z"
                ></path>
            </mask>
            <g mask="url(#mask4_259_730)">
                <path
                    fill="#D1FFBB"
                    d="M245.025 254.583l8.739-1.662s1.28 1.913.831 2.592c-.449.68.108 1.544-.033 1.788a3.41 3.41 0 01-.592.62s2.144-.425 2.365-.332c.26.156.502.34.723.548l-.607.442s.517.637.442 1.035c-.075.399 1.795.333 1.795.333l-2.38 1.444c-1.022.62 1.041.289 1.092.696.052.407 1.602 1.029 1.602 1.029l-16.372 10.783-8.45-12.912 10.845-6.404z"
                ></path>
                <path
                    fill="#000"
                    d="M232.043 270.893l8.807-3.822s-1.636-3.759 1.042-5.943c2.679-2.183 13.142-4.32 15.322-9.97 2.18-5.65 4.889-14.202 3.104-20.963-1.785-6.762 1.845-9.722 7.661-10.001 0 0-7.845-6.195-13.231 4.118s-22.705 46.581-22.705 46.581zM285.072 232.591l3.948 5.381s-7.85-4.632-19.323 5.038c0 0 7.526-6.561 11.684-8.171 4.158-1.61 3.691-2.248 3.691-2.248zM269.146 256.766s18.1-4.608 22.083 0l.057 1.994s-4.545-4.488-22.14-1.994zM252.966 260.43s14.039-8.081 22.02-6.893c0 0-8.729-2.818-22.02 6.893zM275.23 258.267s10.692-.894 12.412 6.148c0-.006-3.169-5.567-12.412-6.148z"
                    opacity="0.55"
                ></path>
                <path
                    fill="#000"
                    d="M267.027 247.361s9.733-10.124 17.975-7.337c.004.001-6.81-1.192-17.975 7.337zM276.231 224.925s-3.988-1.049-7.134 3.352c-3.145 4.4-1.588 9.61-5.036 14.141 0 0 3.881-2.943 4.719-9.295.838-6.353 4.414-8.004 7.451-8.198zM300.101 247.588l-2.692 5.404s-.552-5.12-3.741-7.43c0 0-.731-5.01-4.412-9.189l10.845 11.215z"
                    opacity="0.55"
                ></path>
            </g>
            <path
                fill="#0E7A1A"
                d="M81.392 226.565l2.99-7.146a1.824 1.824 0 00-.592-2.181 1.823 1.823 0 00-.737-.326l-1.103-.228a1.823 1.823 0 00-1.438.299 1.821 1.821 0 00-.754 1.26l-1.018 7.755 2.652.567z"
            ></path>
            <path
                fill="#0E7A1A"
                d="M78.964 226.043s-8.62 1.592-9.575-10.288c0 .009 14.243 3.04 9.575 10.288z"
            ></path>
            <path
                fill="#FFC224"
                d="M73.09 265.577c11.618 0 21.038-9.419 21.038-21.038s-9.42-21.038-21.038-21.038c-11.62 0-21.039 9.419-21.039 21.038s9.42 21.038 21.038 21.038z"
            ></path>
            <mask
                id="mask5_259_730"
                style={{ maskType: "luminance" }}
                width="43"
                height="43"
                x="52"
                y="223"
                maskUnits="userSpaceOnUse"
            >
                <path
                    fill="#fff"
                    d="M73.09 265.577c11.618 0 21.038-9.419 21.038-21.038s-9.42-21.038-21.038-21.038c-11.62 0-21.039 9.419-21.039 21.038s9.42 21.038 21.038 21.038z"
                ></path>
            </mask>
            <g mask="url(#mask5_259_730)">
                <path
                    fill="#000"
                    d="M60.75 219.752l10.106 3.865c-1.968 1.346-8.571 6.223-10.391 14.851-2.127 10.091 3.157 21.191 13.395 27.465l-12.297 6.997-23.788-29.433 22.976-23.745z"
                ></path>
            </g>
            <path
                fill="#1DA332"
                d="M59.033 242.463s-4.439-9.919-13.087-3.381c-3.421 2.585-3.024 4.653-3.024 4.653s-10.424-1.214-10.424 6.992c0 0-14.72 5.378-6.365 11.965 8.356 6.587 45.436.266 45.436.266l-12.536-20.495z"
            ></path>
            <path
                fill="#0E7A1A"
                d="M97.087 218.123l-.297-7.75a1.828 1.828 0 00-2.255-1.717l-1.097.258a1.828 1.828 0 00-1.33 2.338l2.345 7.463 2.634-.592z"
            ></path>
            <path
                fill="#0E7A1A"
                d="M94.668 218.675s-7.146 5.077-13.02-5.294c0 0 14.197-3.246 13.02 5.294z"
            ></path>
            <path
                fill="#FFC224"
                d="M97.134 258.961c11.619 0 21.038-9.419 21.038-21.038s-9.419-21.038-21.038-21.038-21.038 9.419-21.038 21.038 9.419 21.038 21.038 21.038z"
            ></path>
            <mask
                id="mask6_259_730"
                style={{ maskType: "luminance" }}
                width="43"
                height="43"
                x="76"
                y="216"
                maskUnits="userSpaceOnUse"
            >
                <path
                    fill="#fff"
                    d="M97.135 258.961c11.619 0 21.038-9.419 21.038-21.038s-9.419-21.038-21.038-21.038-21.038 9.419-21.038 21.038 9.42 21.038 21.038 21.038z"
                ></path>
            </mask>
            <g mask="url(#mask6_259_730)">
                <path
                    fill="#000"
                    d="M75.5 220.649l10.802-.754c-1.218 2.049-5.151 9.256-3.166 17.847 2.327 10.047 11.8 17.884 23.724 19.26l-8.2 11.528-33.99-16.669 10.83-31.212z"
                ></path>
            </g>
            <path
                fill="#24B73E"
                d="M89.967 248.775s-9.552-8.826-17.853-10.137c-8.3-1.311-9.87 4.576-9.87 4.576s-12.093-1.437-15.382 3.337c0 0-5.168-.133-5.637 3.633-.468 3.765 1.644 8.309 9.396 8.184 0 0-.118 4.653 13.036 3.939a2797.531 2797.531 0 0027.719-1.676l12.795.12s-1.643-3.375 0-6.223c.007-.002-11.034-8.301-14.204-5.753z"
            ></path>
            <path
                fill="#1DA332"
                d="M65.273 242.889s.897-3.36 4.91-4.439c-5.304-.153-7.207 2.991-7.752 4.253 1.689.048 2.842.186 2.842.186zM94.4 260.309s-14.563.956-27.718 1.672c-13.154.716-13.036-3.94-13.036-3.94-7.752.119-9.866-4.416-9.396-8.183.47-3.767 5.637-3.632 5.637-3.632 1.248-1.812 3.759-2.727 6.398-3.168-3.555.19-7.701.984-9.428 3.49 0 0-5.168-.133-5.636 3.633-.469 3.765 1.643 8.308 9.395 8.184 0 0-.118 4.653 13.037 3.938 13.154-.714 27.723-1.672 27.723-1.672l12.796.12s-.062-.128-.148-.351l-9.623-.091z"
            ></path>
            <path
                fill="#70DD7A"
                d="M103.284 254.526H95.73l.892.665-9.96 2.522h10.563l-5.13 1.612 11.965 2.029h10.742s2.23.18 2.044-2.805c-.186-2.984-2.351-2.991-2.351-2.991l-11.211-1.032z"
            ></path>
            <path
                fill="#1DA332"
                d="M82.136 251.585s-4.887-1.994-11.953.319-1.102 7.559-1.102 7.559-2.94-5.296 2.95-6.747c5.89-1.45 10.105-1.131 10.105-1.131zM56.156 251.387s-3.222-4.736 5.45-4.854c0 0-7.162-.04-5.45 4.854zM67.978 248.083s-.876-2.943 2.865-3.421c0 0 .078-2.386 4.415-1.949 0 0-3.779-.167-3.898 2.388-.005 0-3.467-.16-3.382 2.982z"
            ></path>
            <path
                fill="#24B73E"
                d="M78.76 251.866c-7.946-.145-18.069 1.065-21.39 5.483-3.32 4.419 1.405 10.674 7.146 11.192 5.742.519 37.508-.476 41.48.143 3.971.62 9.45-1.595 11.064-6.726-.346-12.976-29.86-9.303-38.3-10.092z"
            ></path>
            <mask
                id="mask7_259_730"
                style={{ maskType: "luminance" }}
                width="62"
                height="18"
                x="56"
                y="251"
                maskUnits="userSpaceOnUse"
            >
                <path
                    fill="#fff"
                    d="M78.76 251.866c-7.946-.145-18.069 1.065-21.39 5.483-3.32 4.419 1.405 10.674 7.146 11.192 5.742.519 37.508-.476 41.48.143 3.971.62 9.45-1.595 11.064-6.726-.346-12.976-29.86-9.303-38.3-10.092z"
                ></path>
            </mask>
            <g mask="url(#mask7_259_730)">
                <path
                    fill="#000"
                    d="M51.058 266.232l5.306-7.46s1.103 4.38 7.62 6.554c6.515 2.174 41.543 1.968 45.154 1.662 3.611-.306 6.908-2.81 6.908-2.81s-2.477 6.723-8.576 8.496c-6.099 1.773-51.573-2.658-51.573-2.658l-4.84-3.784z"
                ></path>
                <path
                    fill="#E4E4E4"
                    d="M52.337 263.877c-.997-.587-2.035-2.783-.307-3.307-.906-1.329.61-2.946.979-4.196.375-1.477-.93-2.928 1.178-3.667 1.075-.323 1.662.192 2.14.604 1.637 1.642 2.68-.418 4.588-.368 1.566 0 1.59-.637 3.277-.602 3.803 1.005.27 2.014 6.508 1.683 1.509-.023 1.57-1.209 3.284-1.146 1.636-.117 3.245-.166 4.819-.321 2.948-.691 2.883.756 4.96 1.241 1.544-.01 1.575-.92 3.277-.874.58.001 1.16.071 1.723.208a6.32 6.32 0 001.537.186c1.684.017 1.684.603 3.256.64 1.524-.013 1.575-1.06 3.282-.997 2.37-.299 4.075-.569 6.541-.582 1.645.023 1.648.205 3.26.231 2.366.304 1.936 2.077 4.842 1.516.73-.068 2.405.166 3.11-.677.94-1.259 3.508-.533 3.973.841.35.721 1.743 1.72 1.967 2.327.224.408.529.766.896 1.052 1.128.88 1.649.262 2.858 1.281 1.019.857 2.073 1.175 1.629 3.003-.201 1.068-1.072 1.224-1.924.857-2.468-1.088-2.177 1.765-4.055 2.578-1.496.649-1.861.736-3.227 1.163-3.791 1.691-3.49.831-6.958-.407-2.589.769-4.183.664-6.747-.049-3.78 1.386-3.028 1.303-6.74-.034-2.714 1.239-3.67 1.48-6.732 1.073-2.749.695-5.871 1.604-8.718.74-1.872-.143-3.227-1.091-4.724-1.872-1.201-.176-2.617 1.142-3.729.851-1.486-.585-3.18-.756-4.738-1.229-3.17-.821-6.843.332-10.03.382-1.73.508-3.596-1.574-5.255-2.129zm.607-2.659c-3.063.871 1.848 2.75 2.722 3.438.83.643.967.619 1.771.476 1.951-.421 4.296-.133 6.382-.562 2.906-.69 6.073.789 8.822 1.437 1.042-.088 2.281-1.078 3.543-.889 3.219 1.807 6.216 2.594 9.97 1.975a14.203 14.203 0 016.75-.645c1.697-.472 3.462-2.086 5.27-.665 1.703 1.261 3.088-.42 4.809-.567 2.943.655 3.746.856 6.739.049 2.16.189 3.245 2.241 5.51.923 1.584-.933 4.42-.804 5.381-2.733.249-.52.558-1.163 1.495-1.561.997-.704 2.877.77 2.938-.131.406-1.143-.545-1.417-1.329-2.095-1.122-.884-1.65-.263-2.858-1.282a4.34 4.34 0 01-1.099-1.286c-.31-.664-1.675-1.628-1.957-2.326-1.496-2.579-2.637.166-4.665.224-1.615-.025-1.623.095-3.265.07-1.752.017-1.755-1.456-3.242-1.552-2.757-.228-5.353-.341-8.04.124-.618.308-2.504.042-3.157.665-.62.686-2.947.678-3.668.221-.641-.365-2.61-.271-3.197-.498-.608-.201-2.362-.333-2.953.196-2.493 1.465-3.19-.484-5.105-.881-2.41.143-4.08.366-6.54.454-.664-.01-.98.209-1.373.498-1.361 1.099-3.425.527-5.178.665-2.16-.176-2.357-2.607-4.712-1.424-.591.415-2.537.149-3.203.758a3.102 3.102 0 01-1.888.561c-1.599.098-1.815-1.568-3.168-1.263-1.256.333-.106 1.87-.551 2.978-.133 1.074-2.011 2.883-.871 3.719.813-.143 2.301-.332 3.49-.166 1.07-.856 1.072-1.936 2.773-2.552.253-.097.567-.456.87-.803 2.585-3.251 3.54.236 8.933-.873a13.75 13.75 0 016.617-.722c1.152-.047 2.26 1.296 3.335 1.346 1.599-.27 3.24-.167 4.755-.959a3.469 3.469 0 013.725-.13c2.604 1.069 4.43-.744 8.158.441 3.475-.693 6.659-1.762 10.005 0 5.793 1.226 5.695-1.774 9.664 2.241 2.195.296 6.201-.884 4.028 2.88-.75.725-.318 1.69-.429 2.476-1.401.276-.562-1.808-2.405-2.203-8.943-2.142-5.347.073-13.157.212-2.418-.089-5.263.893-7.478-.452-1.034-.782-1.983-.515-3.106-.646-1.164-.133-1.943-.261-2.779.931-1.3 1.955-5.352 1.827-7.037.511-1.07-.9-1.662-.887-2.66.15-2.25 2.448-3.848-.289-6.887-.392-2.177-.878-4.34 1.047-6.481-.12-3.324-.962-6.993 1.007-10.285-.367-.73.259-1.308.166-1.888.984-.568-.497-1.22-.697-1.844-.865v.007zm59.95-4.129c-.638-.472-1.306-.278-2.116-.138-1.693.455-3.401-.137-5.126-.201-1.123-.03-2.225-1.044-3.295-1.085-2.222.147-4.434.712-6.647 1.091-5.527-1.273-4.778 1.044-10.016-.952-2.072.831-4.3 1.532-6.62 1.602-1.928-.369-3.06-1.738-5.242-1.432-1.072-.098-1.942-.167-2.964.349-1.602.699-3.42.448-5.099.737-1.163.08-2.351-.909-3.38-.889-1.091.167-1.761 1.855-2.768 2.227-1.24.457-1.33 1.21-2.06 1.978 3.682.874 7.604-.949 11.221.568 1.597-.166 3.3-.964 4.919-.261.486.164.993.258 1.506.278 1.106-.067 2.218 1.121 3.24 1.163.997-.166 2.01-1.964 3.157-1.923 3.376 1.122 1.9 1.896 6.481 1.519 1.749-.997 2.196-2.963 4.805-2.263 3.85-.054 3.454 1.872 8.026 1.243 2.15-.13 4.186-.271 6.286-.383 1.059-.024 2.117-1.146 3.214-1.066 2.571.648 5.781.347 7.786 1.972.3-.719 1.13-1.414.797-2.134-2.919-.222-3.89.692-6.105-2.007v.007z"
                    opacity="0.55"
                ></path>
            </g>
            <path
                fill="#FFCE48"
                d="M51.392 269.088c6.22 0 11.262-5.042 11.262-11.262 0-6.219-5.042-11.261-11.262-11.261-6.22 0-11.262 5.042-11.262 11.261 0 6.22 5.042 11.262 11.262 11.262z"
            ></path>
            <path
                fill="#FFC431"
                d="M51.392 266.64a8.805 8.805 0 01-6.228-15.035 8.813 8.813 0 019.598-1.909 8.812 8.812 0 015.437 8.137 8.824 8.824 0 01-8.807 8.807z"
            ></path>
            <path
                fill="#E4E4E4"
                d="M51.392 248.034a9.796 9.796 0 00-9.05 6.046 9.794 9.794 0 1018.844 3.746 9.802 9.802 0 00-9.794-9.792zm8.026 5.096c.36 1.604-1.028 1.773-1.982 3.109-.665.928-1.973 1.313-2.933 1.474l.347-.166-.53-.203.399-.352-.352-.179-.095-.241.166-.389-.151-.243-.157-.241-.357-.061-.031-.361-.562.254-.1-.289-.182-.199-.275-.028-.2-.2-.308.146-.198-.302-.282.204h-.313c-.228-1.15-.894-5.12.442-6.314a9.22 9.22 0 013.49.831c-.258.51-.856 1.778-.681 2.251a1.42 1.42 0 010 1.047l-1.09 2.119 1.683-2.194s-.93-1.796.528-3.007a9.362 9.362 0 013.724 3.534zm-15.98-.126c1.496-.226 1.185 1.196 1.185 1.196l.936.441a1.352 1.352 0 001.57-.261c-1.975-.593-2.542-2.077-2.698-2.717a9.337 9.337 0 013.84-2.599l-.065.048s1.542 1.683 1.486 2.862c-.037.782.394 2.03.69 2.783l-.059-.046-.144.35-.166.2-.404-.177-.241.13-.072.332-.148.211-.425-.01.241.499-.525-.01-.243.196.166.361.089.297.06.264-.039.241-.125.243-.222.272.389.212.083.229.026.242-.367.428.286.046c-.332.514-.952 1.025-2.089 1.08-2.203.105-2.438 1.154-3.862.457a9.285 9.285 0 01.863-7.788l-.015-.012zm4.798 13.575c-.11-.499-.03-1.419-.03-1.419l.81-.56 1.555-1.273-1.795 1.048c-1.173.683-1.34 1.438-1.314 1.881a9.333 9.333 0 01-2.493-1.708c-.103-.621-.135-1.745.907-2.025 1.39-.374 1.975-1.877 3.625-1.965l.033.112.308-.118h.12l.15.199h.278l.244.075.263-.023.222.332.273.046.27-.103.275.02.183-.388.374.332.056-.567.263-.015.076.037c.31 1.283.853 4.154-.166 5.346-.367.401-.7.832-.997 1.288h-.332a9.311 9.311 0 01-3.158-.552zm11.618-4.892c-.333.02-.96-.15-2.1-1.052-1.983-1.572-3.175-1.385-3.175-1.385s2.315.72 3.063 1.764c.556.774 1.475 1.141 1.91 1.279a9.358 9.358 0 01-3.442 3.548c-.509-.103-1.371-.385-1.53-1.13-.16-.744-.873-2.921-1.262-4.086l.181-.092-.145-.566.233-.112.258-.111.289-.118-.03-.332.429-.09.166-.239-.221-.354.11-.25c1.116-.55 2.223-.423 2.954-.533 1.01-.151.786-1.981 2.413-1.532.28.074.523.252.678.498a9.232 9.232 0 01-.78 4.893z"
            ></path>
        </svg>
    );
}

export default Cooking;